import i18n from 'translations/initTranslation';
import { useToastContainer } from 'modules/layout/toastContainer';
import { useTranslation } from 'react-i18next';
import { ToastType } from 'modules/ui/toast';
import { useState } from 'react';
import { Button, ButtonType } from '../ui/button';
import {
  NavigationAndActionInfoSmall,
  NavigationAndActionEdit,
} from '../ui/icons';

export const getMoreDetailsButton = (onClick: () => void): React.ReactNode => (
  <Button
    type={ButtonType.Action}
    icon={<NavigationAndActionInfoSmall />}
    text={i18n.t('tableButtons.overview')}
    onClick={onClick}
  />
);

export const editButton = (): React.ReactNode => (
  <Button
    type={ButtonType.Action}
    text={i18n.t('tableButtons.edit')}
    icon={<NavigationAndActionEdit />}
  />
);

export const DownloadButton: React.FC<{
  apiCall: () => Promise<any>;
  text?: string;
  fileName: string;
  errorToastTitle?: string;
  errorToastText?: string;
  disabled?: boolean;
}> = ({
  apiCall,
  text,
  fileName,
  errorToastTitle,
  errorToastText,
  disabled,
}) => {
  const { addToast } = useToastContainer();
  const { t } = useTranslation();

  const [downloadDisabled, setDownloadDisabled] = useState(false);

  return (
    <Button
      text={text || t('tableButtons.download')}
      disabled={disabled || downloadDisabled}
      onClick={async () => {
        try {
          setDownloadDisabled(true);

          const response = await apiCall();
          if (response !== undefined) {
            const href = URL.createObjectURL(response);
            const link = document.createElement('a');

            link.href = href;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }

          setDownloadDisabled(false);
        } catch (error) {
          setDownloadDisabled(false);
          addToast({
            title: errorToastTitle || t('tableButtons.downloadErrorToastTitle'),
            text: errorToastText || t('tableButtons.downloadErrorToastText'),
            type: ToastType.Urgent,
          });
        }
      }}
    />
  );
};
